var App = App || {};

App.WidgetCrossPromos = (function ($) {
    'use strict';

    const baseOptions = {
        type: 'loop',
        speed: 500,
        arrows: false,
        pagination: false,
    }

    function Init(selector) {

        if (selector.length) {

            const carousel = selector.find(".widget-crossPromos-carousel");
            const slides = selector.find(".item-crossPromo");
            const controls = selector.find(".widget-crossPromos-controls");

            if (slides.length > 2) {

                const options = {
                    ...baseOptions,
                    padding: { right: '50px' },
                    fixedWidth: '42%',
                    gap: '4rem',
                    mediaQuery: 'max',
                    breakpoints: {
                        575: {
                            padding: { right: '50px' },
                            fixedWidth: '100%',
                            gap: '2rem',
                        }
                    }
                };

                var splide = new Splide(carousel[0], options);
                splide.mount({});
                ControlsShow(controls, splide);
            }

            else if (slides.length == 2) {

                const options = {
                    ...baseOptions,
                    padding: { right: '50px' },
                    fixedWidth: '100%',
                    gap: '2rem'
                };

                var splide = new Splide(carousel[0], options);

                if (ZagBreakpoints.GetBreakpoint() == "xs") {
                    splide.mount({});
                    ControlsShow(controls, splide);
                }

                $(document).on("enter-xs", function () {
                    splide.mount({});
                    ControlsShow(controls, splide);
                });

                $(document).on("enter-sm", function () {
                    splide.destroy({ completely: true });
                    carousel.find(".item-crossPromo").removeAttr("tabindex");
                    ControlsHide(controls);
                });
            }
        }
    }

    function ControlsShow(controls, splide) {
        controls.show().find("button").on("click", function () {
            if ($(this).data("carousel") == "prev")
                splide.go('<');
            else if ($(this).data("carousel") == "next")
                splide.go('>');
        });
    }

    function ControlsHide(controls) {
        controls.hide().find("button").off("click");
    }

    return {
        Init: Init
    };

})(jQuery);